import { UserRole } from "types";

export const allUserRoles = Object.values(UserRole).filter((key) => isNaN(Number(key))) as UserRole[];
